export function createProductionPollingController({
  poll,
  canRun = () => true,
  isHidden = () => false,
  intervalMs = 30000,
  setIntervalFn = window.setInterval,
  clearIntervalFn = window.clearInterval,
} = {}) {
  let timer = null;
  let inFlight = false;

  const run = async () => {
    if (inFlight || !canRun() || isHidden()) return false;
    inFlight = true;
    try {
      await poll?.();
      return true;
    } finally {
      inFlight = false;
    }
  };

  return {
    run,
    start() {
      if (timer == null) timer = setIntervalFn(run, intervalMs);
      return timer;
    },
    stop() {
      if (timer != null) {
        clearIntervalFn(timer);
        timer = null;
      }
    },
  };
}
